import { useEffect, useState } from 'react';
import axios from 'axios';

interface VehicleSide {
	id: string;
	imageUrl: string;
}

interface SidesResponse {
	bodyType: string;
	sides: VehicleSide[];
}

type SideLookup = Record<string, string>;

const BODY_PANEL_ASSETS_URL =
	typeof window !== 'undefined' && window.location.hostname === 'pro.motorway.co.uk'
		? 'https://body-panel-assets.motorway.co.uk'
		: 'https://body-panel-assets.stage.motorway.co.uk';

export const useBodyPanelOverlays = (bodyType: string | undefined): SideLookup => {
	const [lookup, setLookup] = useState<SideLookup>({});

	useEffect(() => {
		if (!bodyType) return;

		const normalised = bodyType.toLowerCase();

		axios
			.get<SidesResponse>(`${BODY_PANEL_ASSETS_URL}/getPanelAsset/`, {
				params: { bodyType: normalised, height: 464 },
				withCredentials: false,
			})
			.then(({ data }) => {
				const map: SideLookup = {};
				for (const side of data.sides) {
					map[side.id] = side.imageUrl;
				}
				setLookup(map);
			})
			.catch(() => {
				// Silently fail — overlays are non-critical
			});
	}, [bodyType]);

	return lookup;
};
